import React from 'react';
const HomeIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9.5L10 4L17 9.5V16H12V12H8V16H3V9.5Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default HomeIcon;

